module.exports = __webpack_public_path__ + "assets/img/hyx_2.2696fc20.png";